import { render, staticRenderFns } from "./RechargeRecord.vue?vue&type=template&id=1b134c70&scoped=true"
import script from "./RechargeRecord.vue?vue&type=script&lang=js"
export * from "./RechargeRecord.vue?vue&type=script&lang=js"
import style0 from "./RechargeRecord.vue?vue&type=style&index=0&id=1b134c70&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b134c70",
  null
  
)

export default component.exports